import { BrowserModule } from '@angular/platform-browser';
import { InjectionToken, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  MSAL_GUARD_CONFIG,
  // MSAL_CONFIG_ANGULAR,
  MsalGuardConfiguration
  , MsalService, MsalModule, MsalInterceptor, MSAL_INSTANCE, MsalGuard, MsalInterceptorConfiguration, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalRedirectComponent
} from '@azure/msal-angular';
import { Configuration } from 'msal';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AJWebService } from '../services/ajWeb.service';

import { HomeComponent } from '../components/home/home.component';
import { DonutChartComponent } from '../DoNutGraph/donut-chart.component';
import { BulletChartComponent } from '../BulletGraph/bullet-chart.component';

import { StandardLineChartComponent } from '../4.0-standard-line-chart/standard-line-chart.component';
import { outcomes_TotSaving_BulletChartComponent } from '../outcomes_bulletChart/outcomes_TotSaving_bullet-chart.component';
import { UseCasesImplementationComponent } from '../useCasesImplementationChart/use-cases-implementation.component';
import { outcomes_TotEffort_BulletChartComponent } from '../outcomes_bulletChart/outcomes_TotEffort_bullet-chart.component';
import { ClusterBarChartTwoComponent } from '../use-Case-Imp-cluster-bar-chart-popup/useCasePopUp-cluster-bar-chart-two.component';
import { SavingHrsBulletChartComponent } from '../savinghrs-bullet-graph/savinghrs-bullet-chart.component';
import { MultilineTickVolTrendingAssetsComponent } from '../ticket-vol-multiline-graph/multiline-tickvol-trending-assets.component'
import { NgxSpinnerModule } from "ngx-spinner";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import {  DatePickerModule  } from '@syncfusion/ej2-angular-calendars';
import { SearchOLPipeComponent } from '../searchFilterPipe';
import { HeatMapChartComponent } from '../heat-map-chart/heat-map-chart.component';
import { HeatMapPopUpChartComponent} from '../heat-map-chart-popUp/heat-map-popup-chart.component';
import { CacheInterceptor } from '../shared/cache-interceptor';
import { TooltipModule } from 'node_modules/ng2-tooltip-directive';
import { SavingHrsBulletChartComponentCompSec } from '../BulletGraph_savinghrs-UnderCompletedSection/savinghrs-bullet-chart.CompSec.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClickOutsideModule } from 'ng-click-outside';
import { MsalApplicationModule } from './msal-application.module';
import { UserAccessComponent } from 'src/user-access/user-access.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ErrorComponent } from 'src/error/error.component';

import { environment } from 'src/environments/environment';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { FTELineChartComponent } from 'src/FTE-line-chart/fte-line-chart.component';
import { DonutChartTicketComponent } from 'src/DonutTicketGraph/donut-chart.component';


// const AUTH_CONFIG_URL_TOKEN = new InjectionToken<string>('AUTH_CONFIG_URL');

// const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

// export function loggerCallback(logLevel: LogLevel, message: string) {
//   console.log(message);
// }
// export function MSALInstanceFactory(): IPublicClientApplication {
//   return new PublicClientApplication({
//     auth: {
//       clientId: environment.webClientID ,//'04dc3950-423d-440a-9e57-af4879c5e5d3'
//       authority: environment.authority,//config.getSettings('authority'),
//       redirectUri: environment.azureRedirectURL,//'https://mywizardaj-saas-stage.accenture.com/',
//      // postLogoutRedirectUri: config.getSettings("azureRedirectURL"),
//       navigateToLoginRequestUrl: true,
//     },
//     cache: {
//       cacheLocation: BrowserCacheLocation.LocalStorage,
//       storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
//     },
//     system: {
//       allowRedirectInIframe: true,
//       loggerOptions: {
//         loggerCallback,
//         logLevel: LogLevel.Info,
//         piiLoggingEnabled: false
//       }
//     }
//   });
// }

// export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {

//   var apiid = environment.apiClientID//config.getSettings('apiClientID');
//   var msalurls = environment.msalAPIurl;//'https://mywizardaj-saasapi-stage.accenture.com';
//   // console.log("PAM API client id",apiid);
//   // console.log("API URL",msalurls);

//   const protectedResourceMap = new Map<string, Array<string>>();
//   protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
//   protectedResourceMap.set(msalurls, [apiid + '/user_impersonation']);

//   return {
//     interactionType: InteractionType.Redirect,
//     protectedResourceMap
//   };
// }

// export function MSALGuardConfigFactory(): MsalGuardConfiguration {
//   return { interactionType: InteractionType.Redirect };
// }

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DonutChartComponent,
    DonutChartTicketComponent,
    outcomes_TotSaving_BulletChartComponent,
    
    StandardLineChartComponent,
    BulletChartComponent,
    outcomes_TotEffort_BulletChartComponent,
    UseCasesImplementationComponent,
    ClusterBarChartTwoComponent,
    
    StandardLineChartComponent,
    SavingHrsBulletChartComponent,
    MultilineTickVolTrendingAssetsComponent,
    FTELineChartComponent,
    SearchOLPipeComponent,
    HeatMapChartComponent,
    HeatMapPopUpChartComponent,
    SavingHrsBulletChartComponentCompSec,
    UserAccessComponent,
    ErrorComponent
    
  ],
  imports: [
    MsalApplicationModule.forRoot('config/config.json'),
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    MsalModule,
    DragDropModule,
    DatePickerModule,
    Ng2SearchPipeModule,
    NgxSpinnerModule,
    TooltipModule,
    ClickOutsideModule,
    MatChipsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  providers: [
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: MsalInterceptor,
    //   multi: true
    // },
    // {
    //   provide: MSAL_INSTANCE,
    //   useFactory: MSALInstanceFactory
    // },
    // {
    //   provide: MSAL_GUARD_CONFIG,
    //   useFactory: MSALGuardConfigFactory
    // },
    // {
    //   provide: MSAL_INTERCEPTOR_CONFIG,
    //   useFactory: MSALInterceptorConfigFactory
    // },
    // MsalService,
    // MsalGuard,
    // MsalBroadcastService,
    // {
    //   provide: LocationStrategy,
    //   useClass: HashLocationStrategy
    // },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: MsalInterceptor,
    //   multi: true
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptor,
      multi: true
    },
     MsalService,
    AJWebService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
